<script lang="ts">
  import Eraser from '@lucide/svelte/icons/eraser';
  import Info from '@lucide/svelte/icons/info';
  import Ellipsis from '@lucide/svelte/icons/ellipsis';
  import Pencil from '@lucide/svelte/icons/pencil';
  import Share2 from '@lucide/svelte/icons/share-2';
  import Upload from '@lucide/svelte/icons/upload';
  import RotateCcw from '@lucide/svelte/icons/rotate-ccw';

  import { getServices } from '../../app/context';
  import { createDefaultDoc } from '../../model/defaults';
  import { clearSelections } from '../../model/ops';
  import { hasUserInput } from '../../model/stats';
  import { strings } from '../../strings';
  import Button from '../../ui/Button.svelte';
  import Dialog from '../../ui/Dialog.svelte';
  import IconButton from '../../ui/IconButton.svelte';
  import Menu, { type MenuItem } from '../../ui/Menu.svelte';

  const { store, toasts, view } = getServices();
  let confirmReset = $state(false);
  let confirmClear = $state(false);

  const items: MenuItem[] = $derived([
    {
      id: 'share',
      label: `${strings.share}…`,
      icon: Share2,
      onselect: () => {
        view.sharing = true;
      },
    },
    {
      id: 'import',
      label: strings.import,
      icon: Upload,
      onselect: () => {
        view.importing = true;
      },
    },
    {
      id: 'edit',
      label: strings.editList,
      icon: Pencil,
      kind: 'checkbox',
      checked: view.editMode,
      onselect: () => {
        view.editMode = !view.editMode;
      },
    },
    {
      id: 'clear',
      separatorBefore: true,
      label: strings.clearRatings,
      icon: Eraser,
      danger: true,
      disabled: !hasUserInput(store.doc),
      onselect: () => {
        confirmClear = true;
      },
    },
    {
      id: 'reset',
      label: strings.resetList,
      icon: RotateCcw,
      danger: true,
      onselect: () => {
        confirmReset = true;
      },
    },
    {
      id: 'about',
      label: strings.about,
      icon: Info,
      separatorBefore: true,
      onselect: () => {
        view.about = true;
      },
    },
  ]);

  function clear() {
    confirmClear = false;
    store.apply(clearSelections);
    toasts.show(strings.clearDone, { action: { label: strings.undo, run: () => store.undo() } });
  }

  function reset() {
    confirmReset = false;
    store.replace(createDefaultDoc(store.newId, new Date(store.doc.updatedAt)));
    toasts.show(strings.resetDone, { action: { label: strings.undo, run: () => store.undo() } });
  }
</script>

<Menu label={strings.moreOptions} {items}>
  {#snippet trigger(props)}
    <IconButton
      label={strings.moreOptions}
      icon={Ellipsis}
      tooltip="bottom"
      tooltipAlign="end"
      {...props}
    />
  {/snippet}
</Menu>

<Dialog
  bind:open={confirmClear}
  title={strings.clearTitle}
  description={strings.clearDescription}
  closeOnBackdrop={false}
  size="sm"
>
  {#snippet footer()}
    <Button onclick={() => (confirmClear = false)}>{strings.cancel}</Button>
    <Button variant="danger" onclick={clear}>{strings.clearConfirm}</Button>
  {/snippet}
</Dialog>

<Dialog
  bind:open={confirmReset}
  title={strings.resetTitle}
  description={strings.resetDescription}
  closeOnBackdrop={false}
  size="sm"
>
  {#snippet footer()}
    <Button onclick={() => (confirmReset = false)}>{strings.cancel}</Button>
    <Button variant="danger" onclick={reset}>{strings.resetConfirm}</Button>
  {/snippet}
</Dialog>
